<script lang="ts">
  import { userContext } from '#lib/context.svelte.ts';
  import { Sections } from '#lib/sections.ts';
  import { goto } from '$app/navigation';
  import { Button } from '@yp/web.app/gui/index.ts';

  const uctx = userContext();
  // export function signIn() {
  //   void FireContext.signInWith('google');
  // }
</script>

<div class="flex-grow flex flex-col flex-start items-center max-w-none">
  <div class="flex-grow inline-block flex flex-col items-stretch gap-4">
    <div class="font-estilo text-4xl text-center my-16">
      <div>New Year's Eve</div>
      <div class="font-bold mt-2 text-5xl"><span class="sub">20</span>25</div>
    </div>
    <div class="flex flex-col justify-center gap-4">
      {#each Object.entries(Sections) as [id, section] (id)}
        {#if (!section.hide || uctx.isAtParty) && section.href !== '/'}
          <Button class="w-full" scheme={section.scheme} onclick={() => goto(section.href)}
            >{section.label}</Button>
        {/if}
      {/each}
    </div>
  </div>
</div>

<style lang="scss">
  .sub {
    font-feature-settings: 'aalt';
  }
</style>
